import { useEffect } from "react";

import { Button, Stack, styled, Typography, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import AccentDanger from "../../../icons/AccentDanger.svg?react";

import { JSX } from "react/jsx-runtime";
import { getQueryParams } from "../../../lib/Util";

const Root = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  gap: "24px",
  backgroundColor: theme.palette.surfaceLight10.main,
}));

type OauthPopupProps = {
  Icon: JSX.Element;
  outcome: string;
  oauthId: string;
};

const OauthPopup = ({ Icon, outcome, oauthId }: OauthPopupProps) => {
  const location = useLocation();
  const theme = useTheme();

  const { route, name } = getQueryParams(location.search);
  const isSuccess = location.pathname === "/oauthsuccess";

  useEffect(() => {
    if (route && window.opener) {
      try {
        const parsed = new URL(route, window.location.origin);
        if (parsed.origin === window.location.origin) {
          window.opener.location.href = route;
        }
      } catch {
        // invalid URL, do nothing
      }
    }
  }, [route]);

  useEffect(() => {
    const handleParentWindowClose = () => {
      if (!isSuccess) return;
      window?.opener?.postMessage({ message: "oauthSuccess", credential_name: name }, window.location.origin);
    };

    window.addEventListener("beforeunload", handleParentWindowClose);

    setInterval(() => {
      window.close();
    }, 3000);

    return () => {
      window.removeEventListener("beforeunload", handleParentWindowClose);
    };
  }, [name, isSuccess]);

  const hasSlash = location.pathname.charAt(0) === "/";
  const title = hasSlash ? outcome : "Error";

  return (
    <Root id={oauthId}>
      {hasSlash ? (
        Icon
      ) : (
        <AccentDanger
          width="54px"
          height="54px"
          color={theme.palette.text10.main}
          fill={theme.palette.accentDanger30.main}
        />
      )}
      <Stack sx={{ gap: "4px", alignItems: "center" }}>
        <Typography variant="body.large.bold">{title}</Typography>
        <Typography variant="body.medium.regular">This window will close automatically.</Typography>
      </Stack>
      <Button variant="outlined" color="secondary" onClick={() => window.close()}>
        Close window
      </Button>
    </Root>
  );
};
export { OauthPopup };
